<template>
  <div id="app">
    <el-container style="height: 100%">
      <el-header class="header">
        <div class="logo-box">
          <!-- <img style="height: 100%" :src="logoImg" /> -->
          <div>ShUI</div>
        </div>
      </el-header>

      <el-container style="height: calc(100% - 60px)">
        <el-aside class="aside">
          <nav-side :data="navsData"></nav-side>
        </el-aside>

        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import navSide from './components/nav-side'
import navsData from './nav.config.json'

export default {
  components: {
    navSide,
  },

  data() {
    return {
      navsData,
    }
  },
}
</script>

<style lang="scss" scoped>
$border-color: #eee;

html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
  background-color: #fff;
}

.header {
  border-bottom: 1px solid $border-color;
  background: #000;

  .logo-box {
    height: 100%;
    display: flex;
    align-items: center;

    img {
      height: 100%;
      margin-right: 16px;
    }
  }

  * {
    color: #fff;
  }
}

.aside {
  height: 100%;
  padding: 0 16px;
  border-right: 1px solid $border-color;
}
</style>
